export async function fetchWithAuth(url: string, token: string, options?: RequestInit) {
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    })

    if (!response.ok) {
      let errorText = 'Request failed'

      try {
        errorText = await response.text()
      } catch (error) {
        console.error('Error reading skills response:', error)
      }

      throw new Error(errorText || `Request failed with status ${response.status}`)
    }

    return await response.json()
  } catch (error) {
    console.error('Error fetching skills data:', error)
    throw error
  }
}
